import {
  AccessTime,
  CalendarToday,
  CheckBoxOutlined,
  Equalizer,
  GroupOutlined,
  Notes,
  StarBorder,
  VideocamOutlined,
} from '@mui/icons-material';
import { IconStethoscope } from '@tabler/icons-react';
import React, { CSSProperties } from 'react';

import { Colors } from 'src/common/ui/base/Colors';

const BOX_SIZE = 32;
const ICON_SIZE = 24;

type IconInBoxProps = {
  children: React.ReactNode;
  size?: number;
  style?: CSSProperties;
};

function IconInBox({ children, size = BOX_SIZE, style }: IconInBoxProps) {
  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
        borderRadius: size * 0.25,
        backgroundColor: Colors.Ice,
        ...style,
      }}
    >
      {children}
    </div>
  );
}

type IconProps = { color?: string; size?: number };

function CheckboxIcon({ color = Colors.Ocean, size = ICON_SIZE }: IconProps) {
  return <CheckBoxOutlined style={{ color, width: size, height: size }} />;
}

function StarIcon({ color = Colors.Ocean, size = ICON_SIZE }: IconProps) {
  return <StarBorder style={{ color, width: size, height: size }} />;
}

function ClockIcon({ color = Colors.Ocean, size = ICON_SIZE }: IconProps) {
  return <AccessTime style={{ color, width: size, height: size }} />;
}

function StethoscopeIcon({ color = Colors.Ocean, size = ICON_SIZE }: IconProps) {
  return <IconStethoscope color={color} width={size} height={size} />;
}

function PeopleIcon({ color = Colors.Ocean, size = ICON_SIZE }: IconProps) {
  return <GroupOutlined style={{ color, width: size, height: size }} />;
}

function EqualizerIcon({ color = Colors.Ocean, size = ICON_SIZE }: IconProps) {
  return <Equalizer style={{ color, width: size, height: size }} />;
}

function CalendarTodayIcon({ color = Colors.Ocean, size = ICON_SIZE }: IconProps) {
  return <CalendarToday style={{ color, width: size, height: size }} />;
}

function VideocamIcon({ color = Colors.Ocean, size = ICON_SIZE }: IconProps) {
  return <VideocamOutlined style={{ color, width: size, height: size }} />;
}

function NotesIcon({ color = Colors.Ocean, size = ICON_SIZE }: IconProps) {
  return <Notes style={{ color, width: size, height: size }} />;
}

IconInBox.Checkbox = CheckboxIcon;
IconInBox.Star = StarIcon;
IconInBox.Clock = ClockIcon;
IconInBox.Stethoscope = StethoscopeIcon;
IconInBox.People = PeopleIcon;
IconInBox.Equalizer = EqualizerIcon;
IconInBox.CalendarToday = CalendarTodayIcon;
IconInBox.Videocam = VideocamIcon;
IconInBox.Notes = NotesIcon;

export default IconInBox;
